import React from 'react';
import { Badge, BadgeType } from '../../../../../../components/badge/badge';
import Section from './section';
import { humanizeKey } from '../../profile-explanation-utils';

interface ICategoryChecksSectionProps {
    categoryChecks: {
        checks?: Array<{
            category?: string;
            status?: string;
            identifier?: string | null;
            rule?: unknown;
            reason?: string;
        }>;
        matching_rules?: Record<string, unknown>;
        rules_count?: number;
    };
}

const CategoryChecksSection: React.FC<ICategoryChecksSectionProps> = ({ categoryChecks }) => {
    return (
        <Section title="Category checks">
            <div className="profile-explanation-category-checks">
                <table className="profile-explanation-category-table">
                    <thead>
                        <tr>
                            <th>Category</th>
                            <th>Identifier</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(categoryChecks.checks ?? []).map((check, i) => (
                            <tr 
                                key={i} 
                                className={`profile-explanation-check-row status-${check.status ?? 'unknown'}`}
                                title={check.reason}
                            >
                                <td className="profile-explanation-check-category">
                                    {humanizeKey(check.category ?? '')}
                                </td>
                                <td className="profile-explanation-check-identifier">
                                    {check.identifier ?? '\u2013'}
                                </td>
                                <td className="profile-explanation-check-status">
                                    <Badge
                                        type={
                                            check.status === 'found' ? BadgeType.SUCCESS :
                                            check.status === 'skipped' ? BadgeType.INFO :
                                            BadgeType.WARNING
                                        }
                                        text={humanizeKey(check.status ?? '')}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Section>
    );
};

export default CategoryChecksSection;
